import { Box, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React, { useEffect, useRef, useState } from 'react'
import { useMeetingStore } from '../../store/meeting.store'
import { secondsToHMS } from '../../utils/utilities'

const OnlineMeetingTimer = ( { timerFor = "start-time", startsAt, type = "countdown", fontSize = `24px`, styles = {}, showIfLessThan = false, triggerIfLessThan, onTriggerIfLessThan, deadline, onShow, onEnd, onHide = () => { } } ) => {

    const [intervalTime, setIntervalTime] = useState( timerFor === "start-time" ? 1000 : 60000 )
    const [timerValue, setTimerValue] = useState( '00:00:00' )
    const [showTimer, setShowTimer] = useState( false )

    const MeetingStore = useMeetingStore()

    const { starts_at, ends_at } = MeetingStore.getCurrentMeeting

    const triggeredIfLessThan = useRef( false )
    const shownTimer = useRef( false )
    const intervalRef = useRef()

    useEffect( () => {
        if ( type === "countdown" ) {
            const target = deadline ? deadline : ( timerFor === "start-time" ? starts_at : ends_at )

            const countdownHandler = () => {
                const diff = ( new Date( target ) - new Date() ) / 1000
                if ( diff <= 0 ) {
                    clearInterval( intervalRef.current )
                    setTimerValue( "00:00:00" )
                    setShowTimer( false )
                    if ( onEnd && typeof onEnd === 'function' ) {
                        onEnd()
                    }
                } else {
                    if ( !showIfLessThan || ( showIfLessThan && diff <= showIfLessThan ) ) {

                        setShowTimer( true )
                        setTimerValue( secondsToHMS( diff ) )
                        if ( intervalTime !== 1000 )
                            setIntervalTime( 1000 )

                        if ( !shownTimer.current && onShow && typeof onShow === 'function' ) {
                            shownTimer.current = true
                            onShow()
                        }

                    } else if ( showIfLessThan && diff > showIfLessThan ) {
                        onHide()
                        setShowTimer( false )
                    }
                    if ( !triggeredIfLessThan.current && triggerIfLessThan && typeof triggerIfLessThan === 'number' && onTriggerIfLessThan && typeof onTriggerIfLessThan === 'function' && triggerIfLessThan > diff ) {
                        onTriggerIfLessThan()
                        triggeredIfLessThan.current = true
                    }
                }

            }
            countdownHandler()
            intervalRef.current = setInterval( countdownHandler, intervalTime )

        } else if ( type === "timer" && startsAt ) {
            intervalRef.current = setInterval( () => {
                const diff = ( new Date() - new Date( startsAt ) ) / 1000

                setTimerValue( secondsToHMS( diff ) )
                setShowTimer( true )
            }, 1000 )
        }


        return () => {
            clearInterval( intervalRef.current )
        }
    }, [starts_at, ends_at, timerFor, intervalTime, showIfLessThan, onShow, onEnd, startsAt, deadline, type, onHide, onTriggerIfLessThan, triggerIfLessThan] )

    return (
        showTimer ? <Typography component="span" sx={styles} fontSize={fontSize}>{timerValue}</Typography> : ""
    )
}

export default OnlineMeetingTimer
